import React from "react";
import { ErrorBoundary, FallbackProps } from "react-error-boundary";

import ErrorFallback from "./ErrorFallback";

type WithErrorBoundaryOptions = {
  fallback?: React.ComponentType<FallbackProps>;
};

export function withErrorBoundary<P extends object>(
  WrappedComponent: React.ComponentType<P>,
  options?: WithErrorBoundaryOptions
): React.FC<P> {
  const componentName =
    WrappedComponent.displayName || WrappedComponent.name || "Component";

  const FallbackComponent = (fallbackProps: FallbackProps) => {
    const CustomFallback = options?.fallback || ErrorFallback;
    return <CustomFallback {...fallbackProps} componentName={componentName} />;
  };

  const ComponentWithErrorBoundary: React.FC<P> = (props) => (
    <ErrorBoundary FallbackComponent={FallbackComponent}>
      <WrappedComponent {...props} />
    </ErrorBoundary>
  );

  return ComponentWithErrorBoundary;
}
